import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { eq } from "@-/com.npmjs.drizzle-orm";

export function useResetGraphemePronunciationCard() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);

  return useMutation({
    mutationFn: async (input: { grapheme: string; pinyin: string }): Promise<void> => {
      const existing = await actorDb(
        import.meta.location,
      ).query.userGraphemePronunciationCard.findFirst({
        where: { grapheme: input.grapheme, pinyin: input.pinyin },
        with: { userCard: true },
      });
      if (existing === undefined) {
        return;
      }

      if (existing.userCard.fsrsCardId === null) {
        await actorDb(import.meta.location)
          .softDelete(actorSchema.userCard)
          .where(eq(actorSchema.userCard.id, existing.userCard.id));
        await actorDb(import.meta.location)
          .softDelete(actorSchema.userGraphemePronunciationCard)
          .where(eq(actorSchema.userGraphemePronunciationCard.userCardId, existing.userCard.id));
        return;
      }

      await actorDb(import.meta.location)
        .update(actorSchema.userGraphemePronunciationCard)
        .set({ description: null })
        .where(eq(actorSchema.userGraphemePronunciationCard.userCardId, existing.userCard.id));
    },
    mutationKey: ["resetGraphemePronunciationCard"],
  });
}
